export enum EntitiesEnum {
    ACCUMULATION,
    USER,
    NOTIFICATIONS,
    WG,
    WG_MEMBER,
}
